import uuidV4 from '../lib/string/uuidV4Utils'
import moment from 'moment'
import { ITEM_STATUS_COMPLETED, ITEM_TYPE_OFFER } from 'constants/cart'
import { OFFER_TYPE_TOUR } from 'constants/offer'
import {
  ACTIVATE_REBOOKING,
  API_CALL,
  API_CALL_SUCCESS,
  APPLY_PROMO_CODE,
  CART_ADD_BEDBANK,
  CART_ADD_FLIGHT,
  CART_ADD_GIFT_CARD,
  CART_ADD_ORDER,
  CART_ADD_PACKAGE,
  CART_ADD_PAYMENT_BALANCE,
  CART_CHANGE_OFFER_PACKAGE,
  CART_EMPTY,
  CART_EMPTY_CHANGE_PACKAGE,
  CART_INITIALISED,
  CART_ORDER_PROCESS_FAILURE,
  CART_PACKAGE_UPSELL_SHOWN,
  CART_PROCESS_CANCEL,
  CART_PROCESS_FAILURE,
  CART_PROCESS_START,
  CART_PROCESS_SUCCESS,
  CART_REMOVE, CART_RESET_RESERVATION_DATES,
  CART_SET_CURRENCY,
  CART_SET_FLIGHTS_AVAILABILITY,
  CART_SET_FLIGHTS_CREDIT_DATA,
  CART_SET_GIFT,
  CART_SET_OFFER,
  CART_SET_RESERVATION_DATES,
  CART_UPDATE_ACCOMMODATION_PRICE,
  CART_UPDATE_ALL_RESERVATIONS,
  CART_UPDATE_FLIGHT_DESTINATION,
  CART_UPDATE_FLIGHT_ORIGIN,
  CART_UPDATE_GIFT_FORM,
  CART_UPDATE_OCCUPANCY,
  CART_UPDATE_RESERVATION,
  CART_UPDATE_RESERVATION_TYPE,
  FLIGHT_JOURNEY_COSTS_UPDATED,
  REMOVE_PROMO_CODE,
  RESET_DEPARTING_FLIGHT,
  RESET_FLIGHT_SELECT,
  RESET_FLIGHTS,
  RESET_RETURNING_FLIGHT,
  SAVE_BOOKING_STATE,
  SET_BOOK_DATES_FOR_ORDER,
  SET_CHANGE_DATES_FOR_ORDER,
  SET_CHANGE_PACKAGE_FOR_ORDER,
  SET_LE_CREDIT_BALANCE,
  START_FLIGHT_CHECKOUT,
  TOGGLE_LE_CREDIT,
  UPDATE_BASE_PRICE_SNAPSHOT,
  UPDATE_DEPARTING_FLIGHT,
  UPDATE_DEPARTING_FLIGHT_SEGMENT_COST,
  UPDATE_FLIGHT_JOURNEY_COST_WITH_ATOL_FEE,
  UPDATE_FLIGHT_JOURNEY_COST_WITH_BOOKING_FEE,
  UPDATE_FLIGHT_JOURNEY_COST_WITH_FLIGHTS_CREDIT_FEE,
  UPDATE_FLIGHT_JOURNEY_COST_WITH_SERVICE_FEE,
  UPDATE_FLIGHT_JOURNEY_COSTS,
  UPDATE_FLIGHT_PRICE_BREAKDOWN,
  UPDATE_INSTALMENT_PLAN,
  UPDATE_PASSENGER_BAGGAGE,
  UPDATE_PAYMENT_SELECTION,
  UPDATE_PERSONALISE_GIFT_CARD_DATA,
  UPDATE_REFERRAL_CODE,
  UPDATE_RETURNING_FLIGHT,
  UPDATE_RETURNING_FLIGHT_SEGMENT_COST,
  UPDATE_TWO_WAY_PASSENGER_BAGGAGE,
} from './actionConstants'

import getPackageFromOffer from 'lib/offer/getPackageFromOffer'
import getPackageFromOfferByKey from 'lib/offer/getPackageFromOfferByKey'
import getPackageFromOfferForOrderItem from 'lib/offer/getPackageFromOfferForOrderItem'
import { RESERVATION_TYPE_INSTANT_BOOKING } from 'constants/reservation'
import {
  CART_RESTORE,
  CART_UPDATE_BEDBANK_SESSION_ID,
  FETCH_BEDBANK_OFFER,
  FETCH_BEDBANK_OFFER_RATES,
  FETCH_DAY_CALENDAR,
  FETCH_FLIGHT_PRICE,
  FETCH_OFFER,
  FETCH_PACKAGE_PRICES,
  FETCH_TAX_BREAKDOWN,
  INITIALISING_CART,
} from './apiActionConstants'
import { fetchTourOrderTravellerDetails } from './OrderActions'
import { getOfferById } from 'api/offer'
import { getOrderWithPaymentsAndReservations } from 'api/order'
import { countOccupantsFromPassengers } from 'lib/flights/countOccupantUtils'
import { countOccupantsForFlights } from 'lib/offer/occupancyUtils'
import { createPassengers, isOneWayFlight, restorePassengersWithBaggage } from 'lib/flights/flightUtils'
import { extractOccupantsFromReservation, getRoomExtraGuestSurcharge } from 'lib/checkout/cartReservationUtils'
import { enquiry } from 'api/bedbank'
import { getCartOccupancies } from 'selectors/cart/cartSelectors'
import {
  CREDIT_PAYMENT_TYPE,
  FLIGHTS_CREDIT_PAYMENT_TYPE,
  PROMO_PAYMENT_TYPE,
  STRIPE_PAYMENT_TYPE,
} from 'constants/payment'
import { bedbankPriceChangeModalOpen, genericOrderErrorModalOpen } from 'actions/UiActions'
import { AppApiAction } from './ActionTypes'
import { getRatesForBedbankOffer } from 'api/bedbankRates'
import { fetchRatesForBedbankOffer, getBedbankRateKey } from './BedbankOfferActions'

import { sum } from 'lib/array/arrayUtils'
import { FlightsCreditDetails } from 'components/Flights/types'

import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import CartInitError from '../errors/CartInitError'
import { scheduleIsCurrent } from 'lib/offer/scheduleStatusUtils'
import generateOccupancyStringByRoom from 'lib/offer/generateOccupancyStringByRoom'
import { getTaxBreakdown, getCalendars } from 'api/calendarV2'
import { getCalendarDay } from 'lib/datetime/calendarUtils'
import { getFlightPrice } from 'api/flights'
import { getFlightPriceKey, isFlightDatesBetweenValidRange } from 'lib/flights/flightUtils'
import { TourDate, tourEnquiry } from 'api/reservation'
import { getPackageUniqueKey } from 'lib/offer/offerUtils'
import { paymentMethodsToString } from 'lib/payment/paymentUtils'
import { GiftForm } from 'components/Booking/Payment/types'
import { showSnackbar } from 'components/Luxkit/Snackbar/AppSnackbar'
import { getDateRangeFromItems } from 'lib/order/orderUtils'
import { addToCart } from 'analytics/snowplow/events'
import * as Analytics from 'analytics/analytics'

export function processingStart() {
  return {
    type: CART_PROCESS_START,
  }
}

export function updatePaymentSelection(value) {
  return {
    type: UPDATE_PAYMENT_SELECTION,
    data: value,
  }
}

export function updateInstalmentPlan(value) {
  return {
    type: UPDATE_INSTALMENT_PLAN,
    data: value,
  }
}

export function processingSuccess(order: App.Order) {
  // analytics events rely on order being set on process success
  // do not change unless you want to re-write analytics!
  return {
    type: CART_PROCESS_SUCCESS,
    order,
  }
}

export function processingCancel() {
  return {
    type: CART_PROCESS_CANCEL,
  }
}

export function processingFailure(name: string, status?: number, errors?: string[]) {
  return (dispatch, getState) => {
    const state = getState() as App.State
    dispatch({
      type: CART_PROCESS_FAILURE,
      data: {
        name,
        status,
        cardProcessingErrorCount: errors && typeof errors[0] === 'string' && errors[0].includes(
          'An error occurred while processing your card',
        ) ? state.cart.cardProcessingErrorCount + 1 : state.cart.cardProcessingErrorCount,
      },
    })
  }
}

export function orderProcessFailure() {
  return {
    type: CART_ORDER_PROCESS_FAILURE,
  }
}

export function cartSetReservationDates(checkIn: string, checkOut: string) {
  return {
    type: CART_SET_RESERVATION_DATES,
    checkIn,
    checkOut,
  }
}

export function cartSetFlightsAvailability(isFlightsAvailable: boolean) {
  return {
    type: CART_SET_FLIGHTS_AVAILABILITY,
    isFlightsAvailable,
  }
}

export function cartResetReservationDates() {
  return {
    type: CART_RESET_RESERVATION_DATES,
  }
}

export function cartUpdateReservation(id: string, reservation: Partial<App.Reservation>) {
  return {
    type: CART_UPDATE_RESERVATION,
    data: reservation,
    id,
  }
}

export function cartUpdateAllReservations(reservation: Partial<App.Reservation>) {
  return {
    type: CART_UPDATE_ALL_RESERVATIONS,
    data: reservation,
  }
}

export function cartEmpty() {
  return {
    type: CART_EMPTY,
  }
}

export function cartEmptyChangePackage(data: Partial<App.CartState> = {}) {
  return {
    type: CART_EMPTY_CHANGE_PACKAGE,
    data,
  }
}

export function addOrderToCart(data: App.Order) {
  return {
    type: CART_ADD_ORDER,
    data,
  }
}

export function cartRemove(id: string) {
  return {
    type: CART_REMOVE,
    id,
  }
}

function defaultHotelReservation(): App.Occupants {
  return {
    adults: 1,
    children: 0,
    infants: 0,
  }
}

function defaultTourReservation(): App.Occupants {
  return {
    adults: 1,
    children: 0,
    infants: 0,
  }
}

function defaultReservation(offerParentType: App.OfferParentType) {
  return offerParentType == OFFER_TYPE_TOUR ?
    defaultTourReservation() :
    defaultHotelReservation()
}

function isSamePackageAndReservationType(
  cart: App.CartState,
  offer: App.Offer | App.OfferSummary,
  offerPackage: App.Package,
  reservationType: App.ReservationType,
) {
  if (!cart.accommodation.offer || !cart.accommodation.package) return false

  return (
    cart.accommodation.offer.id === offer.id &&
    cart.accommodation.package.uniqueKey === offerPackage.uniqueKey &&
    cart.accommodation.reservationType == reservationType
  )
}

export interface PackageInitialiseOptions {
  currencyCode?: string,
  orderItemId?: string,
  occupancies?: Array<App.Occupants>,
  defaultItemStatus?: App.ItemStatus,
  startDate?: string;
  endDate?: string;
  price?: number;
  roomPrices?: number[];
  taxesAndFees?: number;
  propertyFees?: number;
  flightPrice?: number;
  surcharge?: number;
  availableRate?: App.OfferAvailableRate;
  keepCart?: boolean;
  flightOrigin?: string;
  flightDestination?: string;
  flightOriginName?: string;
  flightDestinationName?: string;
  roomRateId?: string;
  numberOfNights?: number;
  availableRooms?: number;
  isChangePackage?: boolean;
}

export function cartInitializePackage(
  offer: App.Offer | App.OfferSummary,
  offerPackage: App.Package,
  reservationType: App.ReservationType,
  options: PackageInitialiseOptions = {},
) {
  return function(dispatch, getState) {
    const state = getState() as App.State
    const { cart, geo } = state
    const { currencyCode, defaultItemStatus, orderItemId, occupancies, isChangePackage } = options
    const currency = currencyCode || geo.currentCurrency
    let packageReservations = occupancies
    if (!packageReservations && isSamePackageAndReservationType(cart, offer, offerPackage, reservationType)) {
      // This preserves the selected guest counts when the use has navigated
      // away from the capacity page and then back to it.
      packageReservations = cart.accommodation.occupancies.map(occupancy => ({ ...occupancy }))
    }

    if (!packageReservations || packageReservations.length === 0) {
      // weren't given any or restored any. Set a default empty reservation package up
      packageReservations = [defaultReservation(offer.parentType)]
    }

    if (!options.keepCart && !isChangePackage) {
      // prep our cart
      dispatch(cartEmpty())
    } else if (isChangePackage) {
      dispatch(cartEmptyChangePackage())
    }
    dispatch(setCartCurrency(currency))
    // set up the correct offer information
    dispatch({
      type: CART_SET_OFFER,
      offer,
      package: offerPackage,
      reservationType,
      cancellationPolicies: options.availableRate?.cancellationPolicies,
      availableRooms: options.availableRooms,
    })

    if (options.startDate && options.endDate) {
      dispatch(cartSetReservationDates(options.startDate, options.endDate))
    }

    if (options.flightPrice) {
      dispatch(cartUpdateBasePriceSnapshot(options.flightPrice))
    }

    const needToAddItems = !cart.items.find(i => orderItemId && i.orderItemId === orderItemId)
    // create all the package items we need for each reservation
    if (needToAddItems) {
      packageReservations.forEach((reservation, index) => {
        dispatch(cartAddPackageItem({
          occupancy: reservation,
          orderItemId,
          status: defaultItemStatus,
          price: options.roomPrices?.[index] ?? options.price,
          taxesAndFees: options.taxesAndFees,
          propertyFees: options.propertyFees,
          surcharge: options.surcharge,
        }))
      })
    }

    if (options.flightOrigin) {
      dispatch(updateCartFlightOrigin(options.flightOrigin, options.flightOriginName))
    }

    if (options.flightDestination) {
      dispatch(updateCartFlightDestination(options.flightDestination, options.flightDestinationName))
    }
    const addToCartEvent = addToCart()
    if (addToCartEvent) Analytics.track('add-to-cart', addToCartEvent)
  }
}

export function cartFetchAndInitialisePackage(
  offerId: string,
  packageId: string,
  reservationType: App.ReservationType,
  options: PackageInitialiseOptions,
) {
  return async(dispatch, getState) => {
    const state = getState() as App.State
    const { geo: { currentRegionCode } } = state

    const offer = await getOfferById(offerId, {
      region: currentRegionCode,
      flightOrigin: options.flightOrigin,
    }) as App.Offer | App.BedbankOffer

    if (offer.type === 'bedbank_hotel') {
      dispatch({
        type: API_CALL_SUCCESS,
        api: FETCH_BEDBANK_OFFER,
        data: offer,
        offerId,
      })

      const {
        flightOrigin,
        flightDestination,
        flightOriginName,
        flightDestinationName,
      } = options

      dispatch(cartFetchAndInitialiseBedbankPackage({
        offerId,
        roomId: packageId,
        rateId: options.roomRateId,
        rooms: options.occupancies,
        checkinDate: options.startDate,
        checkoutDate: moment(options.startDate).add(options.numberOfNights, 'days').format(ISO_DATE_FORMAT),
        isFlightBundle: !(flightOrigin && flightOriginName && flightDestination && flightDestinationName),
        flightOrigin,
        flightDestination,
        flightOriginName,
        flightDestinationName,
      }))
    } else {
      dispatch({
        type: API_CALL_SUCCESS,
        api: FETCH_OFFER,
        data: offer,
        offerId,
      })

      dispatch(cartFetchAndInitialiseLEPackage(offerId, packageId, reservationType, options))
    }
  }
}

export function cartFetchAndInitialiseLEPackage(
  offerId: string,
  packageId: string,
  reservationType: App.ReservationType,
  options: PackageInitialiseOptions,
) {
  return async(dispatch, getState) => {
    const state = getState() as App.State
    const { geo: { currentRegionCode } } = state

    dispatch({
      type: API_CALL,
      api: INITIALISING_CART,
      request: async() => {
        let offer: App.Offer = state.offer.offers[offerId]
        if (!offer) {
          try {
            offer = await getOfferById(offerId, {
              region: currentRegionCode,
              flightOrigin: options.flightOrigin,
            }) as App.Offer

            dispatch({
              type: API_CALL_SUCCESS,
              api: FETCH_OFFER,
              data: offer,
              offerId,
            })
          }
          catch (e) {
            throw new CartInitError({
              type: 'unrecoverable_offer_error',
              code: 'offer_not_found',
              message: 'Offer not found',
            })
          }
        }

        const offerAvailable = scheduleIsCurrent(offer.onlinePurchaseSchedule)
        if (!offerAvailable) {
          throw new CartInitError({
            type: 'unrecoverable_offer_error',
            code: 'offer_sold_out',
            message: 'Offer sold out',
          })
        }

        // Handling invalid url from Android
        let packageOption: App.Package
        if (!options.roomRateId) {
          packageOption = getPackageFromOffer(offer, packageId, options.numberOfNights)
        } else if (options.numberOfNights && options.roomRateId) {
          packageOption = offer.packages.find(p =>
            p.roomRate?.id === options.roomRateId &&
            p.duration === options.numberOfNights &&
            p.id === packageId,
          )
        }

        if (!packageOption) {
          throw new CartInitError({
            type: 'recoverable_offer_error',
            code: 'package_not_found',
            offer,
            message: 'Package not found',
          })
        }

        const startDate = options.startDate ? moment.utc(options.startDate) : undefined
        const endDate = options.endDate ? moment.utc(options.endDate) : startDate?.clone().add(packageOption.duration, 'days')

        let roomPrices: Array<number>
        let taxesAndFees = options.taxesAndFees ?? packageOption.taxesAndFees
        let propertyFees = options.propertyFees ?? packageOption.propertyFees
        let surcharge = options.surcharge
        let availableRooms: number
        let flightPrice: number = options.flightPrice

        if (startDate) {
          if (offer.type === OFFER_TYPE_TOUR) {
            const numTravellers = options.occupancies.length // TODO: Check that tour occupancy is valid
            let dates: TourDate[] = []
            try {
              dates = await tourEnquiry(
                packageOption.tour.id,
                packageOption.tourOption.id,
                packageOption.duration,
                numTravellers,
              )
            } catch (e) {
              throw new CartInitError({
                type: 'recoverable_offer_error',
                code: 'price_not_found',
                offer,
                message: 'Availability information not found',
              })
            }

            const date = dates.find(date => (
              date.startDate === startDate.format(ISO_DATE_FORMAT) &&
              date.endDate === endDate.format(ISO_DATE_FORMAT)
            ))

            if (!date) {
              throw new CartInitError({
                type: 'recoverable_offer_error',
                code: 'tour_date_not_found',
                offer,
                message: 'Tour date not found',
              })
            } else if (date.totalAvailable < numTravellers) {
              throw new CartInitError({
                type: 'recoverable_offer_error',
                code: 'date_not_available',
                offer,
                message: 'Date not available',
              })
            }

            dispatch(cartSetReservationDates(date.startDate, date.endDate))
            dispatch(cartSetFlightsAvailability(date.guaranteedDeparture && isFlightDatesBetweenValidRange(date.startDate, date.endDate)))
          }
          else {
            let calendar: App.Calendar = state.calendar.calendarsByPackageKey[packageOption.uniqueKey]
            // Fetch calendar if we don't already have it
            if (!calendar) {
              try {
                const minDate = moment.utc().add(2, 'days')
                calendar = await getCalendars(
                  offer,
                  currentRegionCode,
                  {
                    occupants: options.occupancies,
                    minDate: minDate.format(ISO_DATE_FORMAT),
                    packages: [packageOption],
                    enquiryType: state.auth.account.isSpoofed ? 'admin' : 'customer',
                    flightOrigin: options.flightOrigin,
                  },
                ).then((calendars) => calendars.find(calendar => calendar.uniqueKey === packageOption.uniqueKey))

                dispatch({
                  type: API_CALL_SUCCESS,
                  api: FETCH_DAY_CALENDAR,
                  key: packageOption.uniqueKey,
                  data: calendar,
                })
              } catch (e) {
                throw new CartInitError({
                  type: 'recoverable_offer_error',
                  code: 'price_not_found',
                  offer,
                  message: 'Availability information not found',
                })
              }
            }

            const calendarDay = getCalendarDay(startDate, calendar)

            if (!calendarDay) {
              throw new CartInitError({
                type: 'recoverable_offer_error',
                code: 'date_not_available',
                offer,
                message: 'Date not available',
              })
            }

            // Calendar returns these numbers as totals for all rooms.
            // Divide by the number of rooms to get per-room numbers.
            const roomCount = (options.occupancies?.length ?? 1)
            roomPrices = calendarDay.roomPrices
            // The Math.ceil here is weird... but that's what the offer page does, and this needs to match that
            taxesAndFees = Math.ceil(calendarDay.taxesAndFees / roomCount)
            propertyFees = calendarDay.propertyFees / roomCount
            surcharge = calendarDay.surcharge / roomCount
            availableRooms = calendarDay.availableRooms

            if (options.flightOrigin && !options.flightPrice) {
              flightPrice = calendarDay.flightPrice
            }
          }
        }

        dispatch(cartInitializePackage(offer, packageOption, reservationType, {
          ...options,
          endDate: endDate?.format(ISO_DATE_FORMAT),
          roomPrices,
          taxesAndFees,
          propertyFees,
          surcharge,
          availableRooms,
          flightPrice,
        }))
      },
    })
  }
}

export function setCartCurrency(currency: string) {
  return {
    type: CART_SET_CURRENCY,
    currency,
  }
}

export interface CartAddPackageItemProps {
  occupancy?: App.Occupants;
  orderItemId?: string;
  status?: App.ItemStatus;
  price?: number;
  taxesAndFees?: number;
  propertyFees?: number;
  surcharge?: number;
}

/**
 * Adds a copy of the currently selected cart package
 */
export function cartAddPackageItem({ occupancy, orderItemId, status, price, taxesAndFees, propertyFees, surcharge }: CartAddPackageItemProps = {}) {
  return (dispatch, getState) => {
    const state = getState() as App.State
    const { cart, geo } = state
    const occupancyData = occupancy || defaultReservation(cart.accommodation.offer.parentType)

    const item = {
      type: ITEM_TYPE_OFFER,
      id: uuidV4(),
      status,
      // the 'price' passed in for tax exclusive regions is always exclusive of tax
      // however, booking is built to assume it's always an inclusive price
      // we fix this here by re-adding the taxes and fees to the price
      price: (price ?? cart.accommodation.package.price) + (geo.isTaxExclusiveRegion ? taxesAndFees ?? 0 : 0),
      value: price ?? cart.accommodation.package.value,
      orderItemId,
      reservation: {
        taxesAndFees: taxesAndFees ?? 0,
        durationSurchargeTotal: surcharge ?? 0,
        extraGuestSurcharge: getRoomExtraGuestSurcharge(cart.accommodation.package, occupancyData, cart.accommodation.offer),
        propertyFees: propertyFees ?? 0,
      },
    } as App.CartItem

    dispatch({
      type: CART_ADD_PACKAGE,
      item,
      occupancy: occupancyData,
    })
  }
}

export function cartAddCompletedOrder(order: App.Order, offer: App.Offer) {
  return async(dispatch) => {
    order.items.filter(i => i.status === 'completed').forEach(item => {
      const occupancies = [{
        adults: item.reservation.adults,
        children: item.reservation.children,
        infants: item.reservation.infants,
        childrenAge: item.reservation.childrenAge,
      }]

      const offerPackage = getPackageFromOfferForOrderItem(offer, item)
      const itemSurcharge = (!item.reservation?.surchargePaidDirectToVendor && item.reservation.surcharge) ?
        item.reservation.surcharge :
        0

      const dates = getDateRangeFromItems(order.items)
      dispatch(cartInitializePackage(
        offer,
        offerPackage,
        item.reservationType,
        {
          currencyCode: order.currencyCode,
          orderItemId: item.id,
          occupancies,
          startDate: dates.earliestCheckInDate,
          endDate: dates.latestCheckOutDate,
          defaultItemStatus: ITEM_STATUS_COMPLETED,
          keepCart: true,
          surcharge: itemSurcharge,
          taxesAndFees: item.reservation.taxesAndFees,
          price: item.packagePrice,
        },
      ))
    })
    dispatch(addOrderToCart(order))
  }
}

export function cartInitialiseGiftCard(price: number, currency?: string) {
  return (dispatch, getState) => {
    const { geo } = getState() as App.State
    dispatch(cartEmpty())
    dispatch(setCartCurrency(currency || geo.currentCurrency))
    dispatch(cartAddGiftCard(price))
    dispatch(setCartInitialised())
  }
}

export function cartInitialisePaymentBalance(price: number, currency?: string) {
  return (dispatch, getState) => {
    const { geo } = getState() as App.State
    dispatch(cartEmpty())
    dispatch(setCartCurrency(currency || geo.currentCurrency))
    dispatch(cartAddPaymentBalance(price))
    dispatch(setCartInitialised())
  }
}

export function cartAddGiftCard(price: number) {
  return {
    type: CART_ADD_GIFT_CARD,
    price,
  }
}

export function cartAddPaymentBalance(price: number) {
  return {
    type: CART_ADD_PAYMENT_BALANCE,
    price,
  }
}

export function updatePersonaliseGiftCardData({
  method,
  to,
  from,
  message,
  emailOfRecipient,
  isBlankMessage,
}) {
  return {
    type: UPDATE_PERSONALISE_GIFT_CARD_DATA,
    data: {
      method,
      to,
      from,
      message,
      email_of_recipient: emailOfRecipient,
      is_blank_message: isBlankMessage,
    },
  }
}

export function cartRestore(cart: Partial<App.CartState>) {
  return (dispatch, getState) => {
    const state = getState() as App.State

    dispatch({
      type: API_CALL,
      api: CART_RESTORE,
      request: async() => {
        if (cart.accommodation?.package && cart.accommodation?.offer) {
          // we only store the ID of the package/offer in local storage
          // this ensures we always get the latest versions when restoring
          const offer = await getOfferById(cart.accommodation.offer.id, {
            region: state.geo.currentRegionCode,
            flightOrigin: cart.flight.flightOrigin,
          }) as App.Offer

          const pkg = offer?.packages.find(p => p.uniqueKey === cart.accommodation.package.uniqueKey)
          if (!offer || !pkg) {
            // don't seem to have access to the offer/pkg anymore, error out
            return Promise.reject('unable to find offer')
          }
          return {
            ...cart,
            accommodation: {
              ...cart.accommodation,
              offer,
              package: pkg,
            },
          } as App.CartState
        }

        return cart
      },
    })
  }
}

export function setLeCreditBalance(currencyCode: string, balance: number, error?: any) {
  return {
    type: SET_LE_CREDIT_BALANCE,
    data: {
      currencyCode,
      balance,
      error,
    },
  }
}

export function toggleLeCredit(useLeCredit: boolean) {
  return {
    type: TOGGLE_LE_CREDIT,
    data: {
      useLeCredit,
    },
  }
}

export function removePromoCode() {
  return {
    type: REMOVE_PROMO_CODE,
  }
}

export function applyPromoCode(promoDetails: App.Promotion) {
  return (dispatch) => {
    dispatch({
      type: APPLY_PROMO_CODE,
      data: promoDetails,
    })
    if (promoDetails.allowedPaymentMethods.length) {
      const message = paymentMethodsToString(promoDetails.allowedPaymentMethods)
      showSnackbar(message, 'success', { heading: 'Promo code applied' })
    }
  }
}

export function activateRebooking(rebookingID) {
  return (dispatch) => {
    dispatch({
      type: ACTIVATE_REBOOKING,
      data: { rebookingID },
    })
  }
}

export function setBookDatesForOrder(order: App.Order) {
  return {
    type: SET_BOOK_DATES_FOR_ORDER,
    data: {
      order,
    },
  }
}

export function setChangeDatesForOrder(order: App.Order, item: App.OrderItem) {
  return {
    type: SET_CHANGE_DATES_FOR_ORDER,
    data: {
      order,
      item,
    },
  }
}

export function setChangePackageForOrder(order: App.Order, item: App.OrderItem) {
  return {
    type: SET_CHANGE_PACKAGE_FOR_ORDER,
    data: {
      order,
      item,
    },
  }
}

export function updateDepartingFlights(journey: App.Journey) {
  const journeyUpdate = {
    ...journey,
  }

  delete journeyUpdate.returning
  return {
    type: UPDATE_DEPARTING_FLIGHT,
    data: journeyUpdate,
  }
}

export function updateReturningFlights(journey: App.Journey) {
  const journeyUpdate = {
    ...journey,
  }

  delete journeyUpdate.departing
  return {
    type: UPDATE_RETURNING_FLIGHT,
    data: journeyUpdate,
  }
}

export function updateFlightPriceBreakdown(priceBreakdown) {
  return {
    type: UPDATE_FLIGHT_PRICE_BREAKDOWN,
    data: priceBreakdown,
  }
}

export function updateFlightJourneyCosts(costs: App.JourneyPricing) {
  return {
    type: UPDATE_FLIGHT_JOURNEY_COSTS,
    data: costs,
  }
}

export function flightJourneyCostsUpdated(updated: boolean) {
  return {
    type: FLIGHT_JOURNEY_COSTS_UPDATED,
    data: updated,
  }
}

export function cartAddFlight() {
  return {
    type: CART_ADD_FLIGHT,
  }
}

export function cartUpdateBasePriceSnapshot(price: number) {
  return {
    type: UPDATE_BASE_PRICE_SNAPSHOT,
    data: price,
  }
}

export function resetFlights() {
  return {
    type: RESET_FLIGHTS,
  }
}

export function resetDepartingFlight() {
  return {
    type: RESET_DEPARTING_FLIGHT,
  }
}

export function resetReturningFlight() {
  return {
    type: RESET_RETURNING_FLIGHT,
  }
}

export function setReferralCode(referralCode: string) {
  return {
    type: UPDATE_REFERRAL_CODE,
    data: {
      referralCode,
    },
  }
}

export function saveBookingState(state: any) {
  return {
    type: SAVE_BOOKING_STATE,
    data: state,
  }
}

export function startFlightCheckout() {
  return (dispatch, getState) => {
    const state = getState() as App.State

    const storedPassengers = state.cart.flight.passengers
    const allParticipants = getCartOccupancies(state)
    const requiredPassengerCounts = countOccupantsForFlights(allParticipants)

    let passengers
    if (storedPassengers) {
      // Attempt to restore passengers with baggage selections.
      // First, verify that the stored passengers array matches with the guest
      // counts in the accommodation items.
      const storedPassengerCounts = countOccupantsFromPassengers(storedPassengers)

      if (storedPassengerCounts.adults === requiredPassengerCounts.adults &&
        storedPassengerCounts.children === requiredPassengerCounts.children &&
        storedPassengerCounts.infants === requiredPassengerCounts.infants) {
        passengers = restorePassengersWithBaggage(storedPassengers)
      }
    }

    if (storedPassengers && allParticipants.length === 0) {
      // Passengers exist in the cart, but not in accommodations or bedbank
      passengers = restorePassengersWithBaggage(storedPassengers)
    }

    if (!passengers) {
      // If we weren't able to restore passenger info, create new passenger array
      passengers = createPassengers(requiredPassengerCounts)
    }

    dispatch({
      type: START_FLIGHT_CHECKOUT,
      passengers,
    })
  }
}

export function updatePassengerBaggage(journeyId: string, baggage: Array<Array<App.AddedBaggage>>) {
  return {
    type: UPDATE_PASSENGER_BAGGAGE,
    data: {
      journeyId,
      baggage,
    },
  }
}

export function updateCartPackage(packageKey: string) {
  return (dispatch, getState) => {
    const state = getState() as App.State
    const offer = state.cart.accommodation.offer
    const newPackage = getPackageFromOfferByKey(offer, packageKey)

    dispatch({
      type: CART_CHANGE_OFFER_PACKAGE,
      package: newPackage,
    })
  }
}

export function setPackageUpsellShown() {
  return {
    type: CART_PACKAGE_UPSELL_SHOWN,
  }
}

export function cartUpdateReservationType(reservationType: App.ReservationType) {
  return {
    type: CART_UPDATE_RESERVATION_TYPE,
    reservationType,
  }
}

export function updateCartPackagePrices(airportCode: string): AppApiAction {
  return (dispatch, getState) => {
    const state = getState()
    const { cart, geo } = state
    const { accommodation } = cart
    const { currentRegionCode } = geo

    dispatch({
      type: API_CALL,
      api: FETCH_PACKAGE_PRICES,
      request: () => getOfferById(accommodation.offer.id, {
        region: currentRegionCode,
        flightOrigin: airportCode,
      }),
    })
  }
}

export function cartFetchAndInitialiseBookDates(orderId: string, orderItemId: string) {
  return (dispatch) => {
    dispatch({
      type: API_CALL,
      api: INITIALISING_CART,
      request: async() => {
        const order = await getOrderWithPaymentsAndReservations(orderId) as App.Order
        const orderItem = order.items.find(i => i.id === orderItemId)
        const offer = await getOfferById(orderItem.offer.id, {
          region: order.regionCode,
        }) as App.Offer

        const pkg = getPackageFromOfferForOrderItem(offer, orderItem)

        dispatch(cartInitializePackage(offer, pkg, RESERVATION_TYPE_INSTANT_BOOKING, {
          orderItemId,
          currencyCode: order.currencyCode,
          occupancies: extractOccupantsFromReservation(orderItem.reservation),
          startDate: orderItem.reservation?.startDate,
          endDate: orderItem.reservation?.endDate,
        }))
        dispatch(setBookDatesForOrder(order))
        if (offer.parentType === OFFER_TYPE_TOUR) {
          dispatch(fetchTourOrderTravellerDetails(orderId))
        }
      },
    })
  }
}

export function cartFetchAndInitialiseChangeDates(orderId: string, orderItemId: string) {
  return (dispatch) => {
    dispatch({
      type: API_CALL,
      api: INITIALISING_CART,
      request: async() => {
        const order = await getOrderWithPaymentsAndReservations(orderId) as App.Order
        const orderItem = order.items.find(i => i.id === orderItemId)
        const offer = await getOfferById(orderItem.offer.id, {
          region: order.regionCode,
        }) as App.Offer

        const pkg = getPackageFromOfferForOrderItem(offer, orderItem)
        dispatch(cartInitializePackage(offer, pkg, RESERVATION_TYPE_INSTANT_BOOKING, {
          orderItemId,
          currencyCode: order.currencyCode,
          occupancies: extractOccupantsFromReservation(orderItem.reservation),
          startDate: orderItem.reservation.startDate,
          endDate: orderItem.reservation.endDate,
        }))
        dispatch(setChangeDatesForOrder(order, orderItem))
      },
    })
  }
}

export function cartFetchAndInitialiseChangePackage(orderId: string, orderItemId: string) {
  return (dispatch) => {
    dispatch({
      type: API_CALL,
      api: INITIALISING_CART,
      request: async() => {
        const order = await getOrderWithPaymentsAndReservations(orderId) as App.Order
        const orderItem = order.items.find(i => i.id === orderItemId)
        const offer = await getOfferById(orderItem.offer.id, {
          region: order.regionCode,
        }) as App.Offer
        const hotelPackage = orderItem?.package as App.OrderItemHotelPackage
        const numberOfNights = orderItem?.reservation?.duration
        const uniqueKey = getPackageUniqueKey(hotelPackage?.id, orderItem.duration, hotelPackage?.roomRateId)

        let pkg
        if (uniqueKey) {
          pkg = getPackageFromOfferByKey(offer, uniqueKey)
        } else {
          pkg = getPackageFromOffer(offer, hotelPackage?.id, numberOfNights)
        }

        dispatch(cartInitializePackage(offer, pkg, RESERVATION_TYPE_INSTANT_BOOKING, {
          orderItemId,
          currencyCode: order.currencyCode,
          occupancies: extractOccupantsFromReservation(orderItem.reservation),
          startDate: orderItem.reservation.startDate,
          endDate: orderItem.reservation.endDate,
          // apparently reservationMap has an error, it maps surcharge attr from
          // svc-reservation's surcharge_total attr which includes peak_period and extra_guest_surcharge
          surcharge: orderItem.reservation.surcharge - orderItem.reservation.extraGuestSurcharge,
          isChangePackage: true,
        }))
      },
    })
  }
}

export function setCartInitialised() {
  return {
    type: CART_INITIALISED,
  }
}

interface CartUpdateAccommodationPriceParams {
  newPrice: number;
  newTaxesAndFees?: number;
  newPropertyFees?: number;
  newSurcharge?: number;
  newExtraGuestSurcharges?: { [cartItemId: string]: number; };
}

export function cartUpdateAccommodationPrice(params: CartUpdateAccommodationPriceParams) {
  return {
    type: CART_UPDATE_ACCOMMODATION_PRICE,
    price: params.newPrice,
    taxesAndFees: params.newTaxesAndFees,
    propertyFees: params.newPropertyFees,
    surcharge: params.newSurcharge,
    extraGuestSurcharges: params.newExtraGuestSurcharges,
  }
}

export function updateCartFlightOrigin(newOriginCode: string, newOriginName: string) {
  return {
    type: CART_UPDATE_FLIGHT_ORIGIN,
    flightOrigin: newOriginCode,
    flightOriginName: newOriginName,
  }
}

export function updateCartFlightDestination(newDestinationCode: string, newDestinationName: string) {
  return {
    type: CART_UPDATE_FLIGHT_DESTINATION,
    flightDestination: newDestinationCode,
    flightDestinationName: newDestinationName,
  }
}

export function updateCartOccupancy(roomIndex: number, occupancy: App.Occupants) {
  return {
    type: CART_UPDATE_OCCUPANCY,
    roomIndex,
    occupancy,
  }
}

export function cartSetGift(value: boolean) {
  return {
    type: CART_SET_GIFT,
    value,
  }
}

export function cartUpdateGiftForm(form: GiftForm | null) {
  return {
    type: CART_UPDATE_GIFT_FORM,
    form,
  }
}

export function cartUpdateBedbankWithLatestRate(newPrice: number) {
  return async function(dispatch, getState) {
    const state = getState() as App.State
    const { checkIn, checkOut, rooms, offer, package: room, rate, bedGroupId } = state.cart.bedbank
    const occupants = rooms.map(room => room.occupancy)

    dispatch(fetchRatesForBedbankOffer(offer, occupants, checkIn, checkOut))

    dispatch({
      type: API_CALL,
      api: CART_UPDATE_BEDBANK_SESSION_ID,
      request: async() => enquiry({
        propertyId: offer.id,
        roomTypeId: room.roomId,
        roomRateId: rate.id,
        bedGroupId,
        isFlightBundle: rate.isFlightBundle,
        region: state.geo.currentRegionCode,
        rooms: occupants,
        checkIn,
        checkOut,
        price: newPrice,
        csBooking: state.auth.account.isSpoofed,
      })
        .then(result => ({ sessionId: result.sessionId, price: result.price }))
        .catch(error => {
          if (error.status === 422) {
            const priceChange = error.errors?.find(e => e.code === 'price_change')
            if (priceChange) {
              dispatch(bedbankPriceChangeModalOpen({
                oldPrice: newPrice,
                newPrice: priceChange.price,
              }))
            }
          }
          throw error
        }),
    })
  }
}

interface BedbankCartFetchAndInitialiseParams {
  offerId: string;
  roomId: string;
  rateId?: string;
  rooms: Array<App.Occupants>;
  checkinDate: string;
  checkoutDate: string;
  savedPrice?: number;
  savedPriceCurrency?: string;
  isFlightBundle: boolean;
  flightOrigin?: string;
  flightDestination?: string;
  flightOriginName?: string;
  flightDestinationName?: string;
  flightPrice?: number;
}

/** Used for restore cart on checkout */
export function cartFetchAndInitialiseBedbankPackage(params: BedbankCartFetchAndInitialiseParams) {
  return async function(dispatch, getState) {
    const state = getState() as App.State
    const { currentRegionCode, currentCurrency } = state.geo

    const {
      offerId,
      roomId,
      rooms,
      rateId,
      checkinDate,
      checkoutDate,
      savedPrice,
      savedPriceCurrency,
      flightOrigin,
      flightDestination,
      flightOriginName,
      flightDestinationName,
    } = params

    dispatch({
      type: API_CALL,
      api: INITIALISING_CART,
      request: async() => {
        let offer = state.offer.bedbankOffers[offerId]
        if (!offer) {
          try {
            offer = await getOfferById(offerId, {
              region: currentRegionCode,
            }) as App.BedbankOffer

            dispatch({
              type: API_CALL_SUCCESS,
              api: FETCH_BEDBANK_OFFER,
              data: offer,
              offerId,
            })
          }
          catch (e) {
            throw new CartInitError({
              type: 'unrecoverable_offer_error',
              code: 'offer_not_found',
              message: 'Offer not found',
            })
          }
        }

        const room = offer.packages.find(pkg => pkg.roomId === roomId)

        if (!room) {
          throw new CartInitError({
            type: 'recoverable_offer_error',
            code: 'room_not_found',
            offer,
            message: 'Room type not found',
          })
        }

        const updatedRatesRequest = {
          checkIn: checkinDate,
          checkOut: checkoutDate,
          rooms,
          region: currentRegionCode,
          id: offerId,
          timezone: offer.property.timezone,
        }

        const newRates = await getRatesForBedbankOffer(updatedRatesRequest)
        const rate = rateId ? newRates.find(rate => rate.id === rateId) : newRates[0]

        if (!rate) {
          throw new CartInitError({
            type: 'recoverable_offer_error',
            code: 'price_not_found',
            offer,
            message: 'Price information not found',
          })
        }

        const priceChanged = typeof savedPrice === 'number' && savedPrice !== rate.totals.inclusive
        const sameCurrency = savedPriceCurrency === currentCurrency

        if (priceChanged && sameCurrency) {
          dispatch(bedbankPriceChangeModalOpen({
            oldPrice: savedPrice,
            newPrice: rate.totals.inclusive,
          }))
        }

        dispatch({
          type: API_CALL_SUCCESS,
          api: FETCH_BEDBANK_OFFER_RATES,
          data: newRates,
          offerId: offer.id,
          filterKey: getBedbankRateKey(rooms, checkinDate, checkoutDate),
        })

        dispatch(cartEmpty())
        dispatch(setCartCurrency(currentCurrency))

        if (flightOrigin && flightDestination) {
          dispatch(updateCartFlightOrigin(flightOrigin, flightOriginName))
          dispatch(updateCartFlightDestination(flightDestination, flightDestinationName))

          const flightPrice: number = params.flightPrice

          // Get cheapest flight price
          if (!flightPrice) {
            try {
              const requestProps: Parameters<typeof getFlightPrice>[0] = {
                startDate: checkinDate,
                endDate: checkoutDate,
                numberOfAdults: sum(rooms, (room) => room.adults),
                numberOfChildren: sum(rooms, (room) => room.children ?? 0),
                numberOfInfants: sum(rooms, (room) => room.infants ?? 0),
                origin: flightOrigin,
                destination: flightDestination,
                currency: currentCurrency,
                region: currentRegionCode,
                nights: moment(checkoutDate).diff(moment(checkinDate), 'days'),
              }
              const flightPrice = await getFlightPrice(requestProps)
              dispatch({
                type: API_CALL_SUCCESS,
                api: FETCH_FLIGHT_PRICE,
                data: flightPrice,
                key: getFlightPriceKey(requestProps),
              })
            } catch (e) {
              // do nothing - we can live without this data
            }
          }

          if (flightPrice) {
            dispatch(cartUpdateBasePriceSnapshot(flightPrice))
          }
        }

        await createSessionAndAddBedbankToCart({
          offer,
          room,
          rate,
          rooms,
          checkinDate,
          checkoutDate,
        }, dispatch, state)
      },
    })
  }
}

interface BedbankCartInitialiseParams {
  offer: App.BedbankOffer;
  room: App.BedbankPackage;
  rate: App.BedbankRate;
  rooms: Array<App.Occupants>;
  checkinDate: string;
  checkoutDate: string;
  flightPrice?: number;
}

export function cartInitialiseBedbankWithLatestRate(params: BedbankCartInitialiseParams) {
  return async function(dispatch, getState) {
    const state = getState() as App.State
    const { offer, room, rooms, rate, checkinDate, checkoutDate } = params

    const updatedRatesRequest = {
      checkIn: checkinDate,
      checkOut: checkoutDate,
      rooms,
      region: state.geo.currentRegionCode,
      id: offer.id,
      timezone: offer.property.timezone,
    }

    const newRates = await getRatesForBedbankOffer(updatedRatesRequest)
    const latestRate = newRates.find(newRate => newRate.id === rate.id && newRate.isFlightBundle === rate.isFlightBundle)

    if (params.flightPrice) {
      dispatch(cartUpdateBasePriceSnapshot(params.flightPrice))
    }

    // spread the update to the latest version of our rates
    dispatch({
      type: API_CALL_SUCCESS,
      api: FETCH_BEDBANK_OFFER_RATES,
      data: newRates,
      offerId: offer.id,
      filterKey: getBedbankRateKey(rooms, checkinDate, checkoutDate),
    })

    dispatch(cartInitializeBedbankWithSession({
      offer,
      room,
      rate: latestRate,
      rooms,
      checkinDate,
      checkoutDate,
    }))
  }
}

export function cartInitializeBedbankWithSession(props: BedbankCartInitialiseParams) {
  return function(dispatch, getState) {
    const state = getState() as App.State
    const { geo } = state

    dispatch(cartEmpty())
    dispatch(setCartCurrency(geo.currentCurrency))
    if (props.flightPrice) {
      dispatch(cartUpdateBasePriceSnapshot(props.flightPrice))
    }

    dispatch({
      type: API_CALL,
      api: INITIALISING_CART,
      request: () => createSessionAndAddBedbankToCart(props, dispatch, state),
    })
  }
}

async function createSessionAndAddBedbankToCart(props: BedbankCartInitialiseParams, dispatch: any, state: App.State) {
  const { geo, auth } = state
  const { offer, room, rate, rooms, checkinDate, checkoutDate } = props

  try {
    const session = await enquiry({
      propertyId: offer.id,
      roomTypeId: room.roomId,
      roomRateId: rate.id,
      isFlightBundle: rate.isFlightBundle,
      region: geo.currentRegionCode,
      rooms,
      checkIn: checkinDate,
      checkOut: checkoutDate,
      price: rate.totals.inclusive,
      csBooking: auth.account.isSpoofed,
    })

    dispatch({
      type: CART_ADD_BEDBANK,
      data: {
        offer,
        rate,
        package: room,
        sessionId: session.sessionId,
        bedGroupId: rate.bedGroups[0].id,
        bookingEmail: auth.account.email,
        bookingPhonePrefix: auth.account.phonePrefix,
        bookingPhonePrefixCountryCode: auth.account.countryCode,
        bookingPhone: auth.account.phone,
        checkIn: checkinDate,
        checkOut: checkoutDate,
        price: rate.totals.inclusive,
        rooms: rooms.map(room => ({
          occupancy: room,
          guestFirstName: auth.account.givenName,
          guestLastName: auth.account.surname,
        })),
      },
    })
  } catch (error) {
    if (error.status === 422) {
      const priceChange = error.errors?.find(e => e.code === 'price_change')
      if (priceChange) {
        dispatch(bedbankPriceChangeModalOpen({
          oldPrice: rate.totals.inclusive,
          newPrice: priceChange.price,
        }))
      }
    }
    throw error
  }
}

export function respondShadowBanUserError(
  paymentType: string,
) {
  return function(dispatch, getState) {
    const state = getState() as App.State

    if (!state.cart.processing) {
      dispatch(processingStart())
    }

    let responseMsg
    switch (paymentType) {
      case CREDIT_PAYMENT_TYPE:
      case PROMO_PAYMENT_TYPE:
        responseMsg = 'An error occurred while processing your card'
        break
      case STRIPE_PAYMENT_TYPE:
        responseMsg = 'Your card was declined. Decline Code: [1]'
        break
      case FLIGHTS_CREDIT_PAYMENT_TYPE:
        responseMsg = 'Flights credit request error'
        break
      default:
        responseMsg = 'Default Error Message'
    }

    setTimeout(() => {
      dispatch(processingFailure(responseMsg, 400, [responseMsg]))
      dispatch(genericOrderErrorModalOpen([responseMsg]))
    }, 3000)
  }
}

export function updateJourneyCost(cost: number) {
  return {
    type: UPDATE_FLIGHT_JOURNEY_COSTS,
    data: { cost },
  }
}

export function updateTotalCostWithBookingFee(bookingFee: number) {
  return {
    type: UPDATE_FLIGHT_JOURNEY_COST_WITH_BOOKING_FEE,
    data: bookingFee,
  }
}

export function updateTotalCostWithServiceFee(serviceFee: number) {
  return {
    type: UPDATE_FLIGHT_JOURNEY_COST_WITH_SERVICE_FEE,
    data: { serviceFee },
  }
}

export function updateTotalCostWithFlightsCreditFee(flightsCreditFee: number) {
  return {
    type: UPDATE_FLIGHT_JOURNEY_COST_WITH_FLIGHTS_CREDIT_FEE,
    data: flightsCreditFee,
  }
}

export function updateTotalCostWithAtolFee(atolFee: number) {
  return {
    type: UPDATE_FLIGHT_JOURNEY_COST_WITH_ATOL_FEE,
    data: atolFee,
  }
}

export function updateTwoWayPassengerBaggages(journeyId: string, baggage: Array<App.AddedBaggage>) {
  return {
    type: UPDATE_TWO_WAY_PASSENGER_BAGGAGE,
    data: {
      journeyId,
      baggage,
    },
  }
}

export function resetFlightSelect() {
  return {
    type: RESET_FLIGHT_SELECT,
  }
}

export function updateFlightCredits(credits: FlightsCreditDetails) {
  return {
    type: CART_SET_FLIGHTS_CREDIT_DATA,
    data: credits,
  }
}

interface InitialiseCartStandaloneFlightParams {
  departingFlight: App.Journey;
  returningFlight?: App.Journey;
  passengers: Array<App.Passenger>;
  originAirportCode: string;
  destinationAirportCode: string;
  destinationAirportName: string;
  originAirportName: string;
  fareType: string;
  creditDetails?: FlightsCreditDetails;
}

export function cartInitialiseStandaloneFlights(params: InitialiseCartStandaloneFlightParams) {
  return function(dispatch, getState) {
    const { geo } = getState() as App.State
    const isOneWayFare = isOneWayFlight(params.fareType)

    dispatch(cartEmpty())
    dispatch(setCartCurrency(geo.currentCurrency))
    dispatch(updateDepartingFlights(params.departingFlight))
    if (!isOneWayFare && params.returningFlight) {
      dispatch(updateReturningFlights(params.returningFlight))
    }
    dispatch(updateCartFlightOrigin(params.originAirportCode, params.originAirportName))
    dispatch(updateCartFlightDestination(params.destinationAirportCode, params.destinationAirportName))
    dispatch({
      type: START_FLIGHT_CHECKOUT,
      passengers: params.passengers,
    })
    dispatch(updateFlightCredits(params.creditDetails))
    dispatch(setCartInitialised())
  }
}

export function fetchTaxBreakdown() {
  return (dispatch, getState) => {
    const state = getState() as App.State
    const { accommodation, currencyCode } = state.cart
    const { currentRegionCode, mainAirport } = state.geo
    if (!accommodation?.offer) {
      return
    }
    const params = {
      offerId: accommodation.offer.id,
      packageId: accommodation.package.id,
      propertyId: accommodation.offer.property.id,
      roomTypeId: accommodation.package.roomType.id,
      roomRateId: accommodation.package.roomRate.id,
      checkIn: accommodation.startDate,
      checkOut: accommodation.endDate,
      occupancies: accommodation.occupancies.reduce((acc: string[], occupancy) => {
        const occupancyString = generateOccupancyStringByRoom(occupancy)
        return acc.includes(occupancyString) ? acc : [...acc, occupancyString]
      }, []),
      region: currentRegionCode,
      nights: accommodation?.package?.duration || 1,
      enquiryType: state.auth.account.isSpoofed ? 'admin' : 'customer',
      currency_code: currencyCode,
      origin: mainAirport?.code,
    }

    dispatch({
      type: API_CALL,
      api: FETCH_TAX_BREAKDOWN,
      request: () => getTaxBreakdown(params),
    })
  }
}

export function updateDepartingFlightSegmentCost(cost: number) {
  return {
    type: UPDATE_DEPARTING_FLIGHT_SEGMENT_COST,
    data: { cost },
  }
}

export function updateReturningFlightSegmentCost(cost: number) {
  return {
    type: UPDATE_RETURNING_FLIGHT_SEGMENT_COST,
    data: { cost },
  }
}
